import { Icon } from '@iconify/react';
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { BASE_URL } from "../../helpers/api";
import { prefillDoctorForBooking } from "../../helpers/doctorPrefill";
import { FaUserCircle } from "react-icons/fa";
import "../../sass/shortcode/DoctorCard.scss";

export default function TeamStyle2({
  picture,
  department,   // department_id
  firstname,
  lastname,
  name,
  degree,
  designation,
  short_biography,
  specialty,    // human-readable name
  specialist,
  doctorId,
  facebook,
  linkedin,
  instagram,
}) {
  const navigate = useNavigate();
  const [booking, setBooking] = useState(false);

  // This card's own shortcut skips the profile page, but it needs the same
  // department list that page uses — a doctor can belong to more than one
  // department, so this isn't safe to pre-fill from the card's own (single)
  // `department` prop alone. Location is never involved here; it isn't a
  // doctor property (see helpers/doctorPrefill.js).
  const handleBookAppointment = async () => {
    if (!doctorId) {
      navigate("/appointments");
      return;
    }
    setBooking(true);
    try {
      const res = await fetch(`${BASE_URL}/doctors/${doctorId}`);
      const doctorData = await res.json();
      prefillDoctorForBooking(doctorData?.error ? { id: doctorId, name, degree, specialist } : doctorData);
    } catch (err) {
      // Fall back to just the doctor identity — better than sending the
      // patient to a booking form with nothing pre-filled at all.
      prefillDoctorForBooking({ id: doctorId, name, degree, specialist });
    } finally {
      setBooking(false);
      navigate("/appointments");
    }
  };

  return (
    <div className="cs_doc_card">
      <span className="cs_doc_card_blob_top" />
      <span className="cs_doc_card_blob_bottom" />
      <span className="cs_doc_card_dots" />

      <div className="cs_doc_card_avatar">
        {picture ? (
          <img src={picture} alt={name} />
        ) : (
          <FaUserCircle />
        )}
      </div>

      {specialty && (
        <div className="cs_doc_card_badge">
          <span className="cs_doc_card_badge_icon">
            <Icon icon="fa6-solid:mortar-pestle" />
          </span>
          <span>{specialty} Department</span>
        </div>
      )}

      <h3 className="cs_doc_card_name">
        {doctorId ? <Link to={`/doctors/${doctorId}`}>{name}</Link> : name}
      </h3>

      <div className="cs_doc_card_divider">
        <hr />
        <span className="cs_doc_card_role_icon">
          <Icon icon="mdi:shield-account-outline" />
        </span>
        <hr />
      </div>
      <p className="cs_doc_card_role">{specialist || degree}</p>

      <button onClick={handleBookAppointment} className="cs_doc_card_btn" disabled={booking}>
        <Icon icon="mdi:calendar-month-outline" />
        {booking ? "Please wait..." : "Book Appointment"}
      </button>
    </div>
  );
}
